//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Updates GDT message status on Stored
 */
export function storeOutgoingMessage(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/gdt/out-messages/{id}/stored";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStoreOutgoingMessage,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigStoreOutgoingMessage?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStoreOutgoingMessage(_response);
    });
}

function processStoreOutgoingMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Updates GDT message status on Processed
 */
export function processOutgoingMessage(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/gdt/out-messages/{id}/processed";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessOutgoingMessage,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigProcessOutgoingMessage?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessOutgoingMessage(_response);
    });
}

function processProcessOutgoingMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sends message regarding measurement
 */
export function sendMeasurementMessage(measurementId: number, dto: Types.SendGDTMessageDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/gdt/out-messages/measurement/{measurementId}";
    if (measurementId === undefined || measurementId === null)
      throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSendGDTMessageDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendMeasurementMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendMeasurementMessage?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendMeasurementMessage(_response);
    });
}

function processSendMeasurementMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sends message regarding document
 */
export function sendDocumentMessage(documentId: string, dto: Types.SendGDTMessageDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/gdt/out-messages/document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSendGDTMessageDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendDocumentMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendDocumentMessage?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendDocumentMessage(_response);
    });
}

function processSendDocumentMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets not sent GDT outgoing messages. This method is only for the transporter.
We don't want to give the transporter access to all messages and filter them.
 */
export function getNotSentMessages(config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfGDTMessageDto> {
    let url_ = getBaseUrl() + "/api/gdt/out-messages/not-sent";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetNotSentMessages,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetNotSentMessages?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetNotSentMessages(_response);
    });
}

function processGetNotSentMessages(response: AxiosResponse): Promise<Types.PageableListDtoOfGDTMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfGDTMessageDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfGDTMessageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfGDTMessageDto>(null as any);
}
let _requestConfigStoreOutgoingMessage: Partial<AxiosRequestConfig> | null;
export function getStoreOutgoingMessageRequestConfig() {
  return _requestConfigStoreOutgoingMessage;
}
export function setStoreOutgoingMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStoreOutgoingMessage = value;
}
export function patchStoreOutgoingMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStoreOutgoingMessage = patch(_requestConfigStoreOutgoingMessage ?? {});
}

let _requestConfigProcessOutgoingMessage: Partial<AxiosRequestConfig> | null;
export function getProcessOutgoingMessageRequestConfig() {
  return _requestConfigProcessOutgoingMessage;
}
export function setProcessOutgoingMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessOutgoingMessage = value;
}
export function patchProcessOutgoingMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessOutgoingMessage = patch(_requestConfigProcessOutgoingMessage ?? {});
}

let _requestConfigSendMeasurementMessage: Partial<AxiosRequestConfig> | null;
export function getSendMeasurementMessageRequestConfig() {
  return _requestConfigSendMeasurementMessage;
}
export function setSendMeasurementMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendMeasurementMessage = value;
}
export function patchSendMeasurementMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendMeasurementMessage = patch(_requestConfigSendMeasurementMessage ?? {});
}

let _requestConfigSendDocumentMessage: Partial<AxiosRequestConfig> | null;
export function getSendDocumentMessageRequestConfig() {
  return _requestConfigSendDocumentMessage;
}
export function setSendDocumentMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendDocumentMessage = value;
}
export function patchSendDocumentMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendDocumentMessage = patch(_requestConfigSendDocumentMessage ?? {});
}

let _requestConfigGetNotSentMessages: Partial<AxiosRequestConfig> | null;
export function getGetNotSentMessagesRequestConfig() {
  return _requestConfigGetNotSentMessages;
}
export function setGetNotSentMessagesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetNotSentMessages = value;
}
export function patchGetNotSentMessagesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetNotSentMessages = patch(_requestConfigGetNotSentMessages ?? {});
}